/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   03/11/2022
 */

const stateNames: Record<string, Record<string, string>> = {
	AU: {
		ACT: "Australian Capital Territory",
		NSW: "New South Wales",
		NT: "Northern Territory",
		QLD: "Queensland",
		SA: "South Australia",
		TAS: "Tasmania",
		VIC: "Victoria",
		WA: "Western Australia"
	},
	US: {
		AL: "Alabama",
		AK: "Arkansas",
		AZ: "Arizona",
		CA: "California",
		CO: "Colorado",
		CT: "Connecticut",
		DE: "Delaware",
		FL: "Florida",
		GA: "Georgia",
		HI: "Hawaii",
		ID: "Idaho",
		IL: "Illinois",
		IN: "Indiana",
		IA: "Iowa",
		KS: "Kansas",
		KY: "Kentucky",
		LA: "Louisiana",
		ME: "Maine",
		MD: "Maryland",
		MA: "Massachusetts",
		MI: "Michigan",
		MN: "Minnesota",
		MS: "Mississippi",
		MO: "Missouri",
		MT: "Montana",
		NE: "Nebraska",
		NV: "Nevada",
		NH: "New Hampshire",
		NJ: "New Jersey",
		NM: "New Mexico",
		NY: "New York",
		NC: "North Carolina",
		ND: "North Dakota",
		OH: "Ohio",
		OK: "Oklahoma",
		OR: "Oregon",
		PA: "Pennsylvania",
		RI: "Rhode Island",
		SC: "South Carolina",
		SD: "South Dakota",
		TN: "Tennessee",
		TX: "Texas",
		UT: "Utah",
		VT: "Vermont",
		VA: "Virginia",
		WA: "Washington",
		WV: "West Virginia",
		WI: "Wisconsin",
		WY: "Wyoming",
		DC: "District of Columbia",
		AS: "American Samoa",
		GU: "Guam",
		MP: "Northern Mariana Islands",
		PR: "Puerto Rico",
		VI: "U.S. Virgin Islands"
	},
	CA: {
		ON: "Ontario",
		QC: "Quebec",
		NS: "Nova Scotia",
		NB: "New Brunswick",
		MB: "Manitoba",
		BC: "British Columbia",
		PE: "Prince Edward Island",
		SK: "Saskatchewan",
		AB: "Alberta",
		NL: "Newfoundland and Labrador"
	},
	DE: {
		BW: "Baden-Wurttemberg",
		BY: "Bavaria",
		BE: "Berlin",
		BB: "Brandenburg",
		HB: "Bremen",
		HH: "Hamburg",
		HE: "Hesse",
		SN: "Saxony",
		ST: "Saxony-Anhalt",
		NI: "Lower Saxony",
		MV: "Mecklenburg-Vorpommern",
		NW: "North Rhine-Westphalia",
		RP: "Rhineland-Palatinate",
		SL: "Saarland",
		SH: "Schleswig-Holstein",
		TH: "Thuringia"
	},
	NZ: {
		AUK: "Auckland",
		CAN: "Canterbury",
		CIT: "Chatham Island",
		HKB: "Hawke's Bay",
		MBH: "Marlborough",
		NSN: "Nelson",
		OTA: "Otago",
		STL: "Southland",
		TKI: "Taranaki",
		WGN: "Wellington"
	},
	IN: {
		KT: "Karnataka",
		TN: "Tamil Nadu",
		NCR: "Haryana",
		MH: "Maharashtra",
		TS: "Telangana",
		EI: "Eastern States"
	}
}

export default stateNames;